import { z } from 'zod'
import { addDays, startOfDay } from 'date-fns'
import {
  requiredSelect,
  requiredPositiveInteger,
  optionalString,
  createResourceSchema
} from './common'

const MIN_LEAD_DAYS = 10

export const printOrderSchema = createResourceSchema({
  print_asset_id: requiredSelect('Print asset'),
  date: z.string().min(1, 'Desired delivery date is required').refine((val) => {
    const selected = new Date(val + 'T00:00:00')
    const minDate = startOfDay(addDays(new Date(), MIN_LEAD_DAYS))
    return selected >= minDate
  }, `Desired delivery date must be at least ${MIN_LEAD_DAYS} days from today`),
  quantity: requiredPositiveInteger('Quantity'),
  notes: optionalString,
  position_ids: z.array(z.string()).min(1, 'Select at least one location').max(20, 'Cannot exceed 20 locations')
})
